var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg48Graphql(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e8457c",
    d: "M24.5,44.661L7,34.32V13.68L24.5,3.339L42,13.68v20.64L24.5,44.661z M9,33.18l15.5,9.159L40,33.18 V14.82L24.5,5.661L9,14.82V33.18z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 5,
    r: 4,
    fill: "#e8457c"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 43,
    r: 4,
    fill: "#e8457c"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 33,
    r: 4,
    fill: "#e8457c"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 33,
    r: 4,
    fill: "#e8457c"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 15,
    r: 4,
    fill: "#e8457c"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 15,
    r: 4,
    fill: "#e8457c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8457c",
    d: "M42.72,34.5H6.28L24.5,2.478L42.72,34.5z M9.72,32.5h29.56L24.5,6.522L9.72,32.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg48Graphql);
export default __webpack_public_path__ + "static/media/48-graphql.0a40edac88a2147bd86c36d4a7eecbc7.svg";
export { ForwardRef as ReactComponent };